module.exports = __webpack_public_path__ + "img/meal.03c0d45a.png";